const DEPARTMENTS = {
  ENG: 'Eng',
  OPS: 'Ops',
  SALES: 'Sales',
  CS: 'CS',
};

export default DEPARTMENTS;
